import * as actionTypes from './actionTypes'


export const getUserInfoData = () => ({
    type: actionTypes.GET_USER_INFO_DATA
})

export const setUserInfoData = data => ({
    type: actionTypes.SET_USER_INFO_DATA,
    data
})
export const setUserInfoMsgData = data => ({
    type: actionTypes.SET_USER_INFO_MSG_DATA,
    data
})

export const setHistoryData = data => ({
    type: actionTypes.SET_HISTORY_DATA,
    data
})




